var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.40759 14.8945C7.14667 14.4075 7 13.8543 7 13.27C7 11.9775 8.07217 10.9827 9.3283 10.9827H9.346C8.82234 10.4426 8.5 9.70621 8.5 8.89453C8.5 8.12618 8.78885 7.42529 9.26389 6.89453H2V12.3945C2 13.7752 3.11929 14.8945 4.5 14.8945H7.40759ZM14 5.89453V5.39453C14 4.01382 12.8807 2.89453 11.5 2.89453H4.5C3.11929 2.89453 2 4.01382 2 5.39453V5.89453H14ZM11.5 10.8945C12.6046 10.8945 13.5 9.9991 13.5 8.89453C13.5 7.78996 12.6046 6.89453 11.5 6.89453C10.3954 6.89453 9.5 7.78996 9.5 8.89453C9.5 9.9991 10.3954 10.8945 11.5 10.8945ZM9.3283 11.9827C8.5947 11.9827 8 12.559 8 13.27C8 14.4196 8.80726 15.4216 9.95798 15.7004L10.0406 15.7204C10.9988 15.9526 12.0012 15.9526 12.9594 15.7204L13.042 15.7004C14.1927 15.4216 15 14.4196 15 13.27C15 12.559 14.4053 11.9827 13.6717 11.9827H9.3283Z",
    fill: "#F1F2F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.d1bb89da13ae09574aa9c1653279f2b6.svg";
export { ForwardRef as ReactComponent };